import {Component, Inject, OnInit} from '@angular/core';
import {DialogConfigBase} from '../dialog-config-base';
import {DialogConfigInterface} from '../dialog-config.interface';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material';
import {TranslationContainerComponent} from '../../abstract/translation-container.component';
import {DialogComponentInterface} from '../dialog-component.interface';
import {logoUrl, salesChannel} from 'src/app/core/utils/utils';
import {StepKey} from '../../../../core/enums/step-key.enum';
import {OfferService} from '../../../../core/services/impl/offer.service';
import {NavigateManagerService} from '../../../../core/services/navigate-manager.service';
import {SalesChannel} from '../../../../core/consts/sales-channel.enum';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Component({
  selector: 'app-offer-unavailable-dialog',
  templateUrl: './offer-unavailable-dialog.component.html'
})
export class OfferUnavailableDialogComponent extends TranslationContainerComponent implements OnInit, DialogComponentInterface {

  logoUrl: string = logoUrl();
  additionalLogoUrl: string;
  logoVisible: boolean = true;
  imageUrl: string = './assets/images/offer-unavailable.svg';

  private config: OfferUnavailableDialogSalesChannelConfig;
  private readonly SALES_CHANNEL_CONFIGS: OfferUnavailableDialogSalesChannelConfig[] = [
    {
      salesChannel: SalesChannel.YANOSIK,
      logoUrl: './assets/images/logo/yanosik-black.svg',
      imageUrl: './assets/images/offer-unavailable-yanosik.svg'
    },
    {
      salesChannel: SalesChannel.BANKIER,
      imageUrl: './assets/images/offer-unavailable-bankier.svg'
    },
    {
      salesChannel: SalesChannel.CARONE,
      logoDisabled: true,
      imageUrl: './assets/images/offer-unavailable-carone.svg'
    },
    {
      salesChannel: SalesChannel.MPAY,
      imageUrl: './assets/images/offer-unavailable-mpay.svg'
    },
    {
      salesChannel: SalesChannel.NESTBANK,
      imageUrl: './assets/images/offer-unavailable-nestbank.svg',
      additionalLogoUrl: './assets/images/logo/nestbank-logo.svg'
    },
    {
      salesChannel: SalesChannel.SKYCASH,
      imageUrl: './assets/images/offer-unavailable-skycash.svg'
    }
  ];

  static getConfigBuilder(): OfferUnavailableDialogConfig {
    return new OfferUnavailableDialogConfig();
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private dialog: MatDialogRef<OfferUnavailableDialogComponent>,
              private offerService: OfferService,
              private navigateManager: NavigateManagerService) {
    super('OFFER_UNAVAILABLE_DIALOG');
  }

  ngOnInit() {
    this.initConfig();
    this.initLogos();
    this.initImage();
  }

  backToOffers(): void {
    this.dialog.close();
    this.offerService.sendCalculation().then(() => this.navigateManager.moveToStep(StepKey.SECOND_STEP));
  }

  private initConfig(): void {
    this.config = this.SALES_CHANNEL_CONFIGS.find(item => item.salesChannel === salesChannel());
  }

  private initLogos(): void {
    if (isNotNullOrUndefined(this.config) && isNotNullOrUndefined(this.config.logoUrl)) {
      this.logoUrl = this.config.logoUrl;
    }
    if (isNotNullOrUndefined(this.config) && isNotNullOrUndefined(this.config.logoDisabled)) {
      this.logoVisible = !this.config.logoDisabled;
    }
    if (isNotNullOrUndefined(this.config) && isNotNullOrUndefined(this.config.additionalLogoUrl)) {
      this.additionalLogoUrl = this.config.additionalLogoUrl;
    }
  }

  private initImage(): void {
    if (isNotNullOrUndefined(this.config) && isNotNullOrUndefined(this.config.imageUrl)) {
      this.imageUrl = this.config.imageUrl;
    }
  }

}

export interface OfferUnavailableDialogSalesChannelConfig {
  salesChannel: SalesChannel;
  logoUrl?: string;
  additionalLogoUrl?: string;
  logoDisabled?: boolean; // default - false
  imageUrl?: string;
}

export class OfferUnavailableDialogConfig extends DialogConfigBase implements DialogConfigInterface {
  private config: MatDialogConfig = {
    panelClass: ['app-dialog', 'offer-unavailable-dialog-panel'],
    disableClose: true,
    autoFocus: false
  };

  constructor() {
    super();
  }

  buildConfiguration(data: any): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}
